//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'

import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../../../components/QSelectUtils.js'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    request: {
      type: Object,
      default: () => {
        return {}
      }
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      applicantWorkAreaFieldConfig: createFieldConfig({ allRecordsFn: this.getApplicantWorkAreas }),
      costDetailsProjectFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getProjects,
        cached: false,
        storeType: 'server',
        fullReadable: true,
        searchable: true,
        searchFiltrationBySource: false,
        searchValueMinLength: 0
      })),
      costDetailsProjectColumns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          searchable: true, // !!!
          sortable: true
        }
      ]
    }
  },
  computed: {
    costDetailsServiceDuration: {
      get: function () {
        return this.request.costDetailsServiceDuration != null ? Math.floor(this.request.costDetailsServiceDuration / (1000 * 60 * 60)) : null
      },
      set: function (value) {
        this.request.costDetailsServiceDuration = null

        if (value != null) {
          this.request.costDetailsServiceDuration = value * 1000 * 60 * 60
        }
      }
    },
    serviceDuration: function () {
      return this.request.endServiceTime != null && this.request.startServiceTime != null && this.request.endServiceTime >= this.request.startServiceTime ? this.request.endServiceTime - this.request.startServiceTime : this.request.serviceDuration
    },
    vehicleOdometerDistance: function () {
      if (this.request.vehicleOdometerFaulty) {
        return this.request.vehicleOdometerDistance
      } else {
        return !!this.request.startVehicleOdometerValue && !!this.request.endVehicleOdometerValue && this.request.endVehicleOdometerValue >= this.request.startVehicleOdometerValue ? this.request.endVehicleOdometerValue - this.request.startVehicleOdometerValue : null
      }
    }
  },
  methods: {
    onOpenCard: function (event, object, type, subtypeKey) {
      if (object.id && type) {
        this.$d_showObjectCard(object.id, type, event.ctrlKey, false, subtypeKey)
      }
    },

    /**
     * Проект
     */
    getProjects: function () {
      const params = [{
        param: 'status',
        type: 'listvalue',
        action: '!=',
        value: 'nonactive'
      }]
      return this.searchObjects('project', params)
    },
    searchObjects: function (propertyKey, params) {
      const encodedParams = encodeURIComponent(JSON.stringify(params))
      return axiosGet({
        url: '/service/obj/search?params=' + encodedParams + '&nameField=name&type=' + propertyKey + '&limit=1000&sort=name',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },

    getApplicantWorkAreas: function () {
      return this.getPropertyValues('applicantWorkAreas')
    },
    getPropertyValues: function (propertyKey, props) {
      const params = new URLSearchParams()
      params.set('property', propertyKey)
      if (props) {
        params.set('properties', JSON.stringify(props))
      }

      return axiosGet({
        url: '/service/delta/vehicleProvision/propertyValues?' + params.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },

    validateFields: function (validFieldKeys) {
      validFieldKeys.forEach(validFieldKey => {
        if (this.$refs[validFieldKey]) {
          this.$refs[validFieldKey].validate()
        }
      })
    }
  }
}

